// Booking Form Stability Improvements
// Handles form validation, error recovery, and user experience improvements

let bookingFormInitialized = false;

document.addEventListener("turbolinks:load", function() {
    if (!bookingFormInitialized) {
        initializeBookingFormStability();
    }
});

function initializeBookingFormStability() {
    if (bookingFormInitialized) return;
    bookingFormInitialized = true;

    // Add loading indicators for AJAX requests
    addLoadingIndicators();
    
    // Improve form validation
    enhanceFormValidation();
    
    // Add retry mechanism for failed AJAX calls
    setupAjaxRetry();
    
    // Navigation warning removed - was interfering with user experience
    // handleBrowserNavigation();
}

function addLoadingIndicators() {
    // Add loading spinner for date/time selection
    const tourDateSelect = document.getElementById('tourDateSelect');
    const tourTimeSelects = document.querySelectorAll('.tour-time-select');
    
    if (tourDateSelect) {
        tourDateSelect.addEventListener('change', function() {
            tourTimeSelects.forEach(select => {
                if (select) {
                    select.innerHTML = '<option disabled>Loading times...</option>';
                    select.classList.add('loading');
                }
            });
        });
    }
}

function enhanceFormValidation() {
    // Only target specific booking forms
    const forms = document.querySelectorAll('#freeTourForm, #sharedTourForm');
    
    forms.forEach(form => {
        const submitBtn = form.querySelector('input[type="submit"], button[type="submit"]');
        if (!submitBtn) return;
        
        // Intercept CLICK on submit button BEFORE Rails UJS can disable it
        submitBtn.addEventListener('click', function(e) {
            const requiredFields = form.querySelectorAll('[required]');
            let hasErrors = false;
            
            requiredFields.forEach(field => {
                // Remove any stale readonly from selects
                if (field.tagName === 'SELECT') {
                    field.removeAttribute('readonly');
                }
                
                // For select elements, check if the selected option is disabled (placeholder)
                let isEmpty = false;
                if (field.tagName === 'SELECT') {
                    const selectedOption = field.options[field.selectedIndex];
                    isEmpty = !field.value.trim() || (selectedOption && selectedOption.disabled);
                } else if (field.type === 'checkbox') {
                    isEmpty = !field.checked;
                } else {
                    isEmpty = !field.value.trim();
                }
                
                if (isEmpty) {
                    field.classList.add('is-invalid');
                    hasErrors = true;
                } else {
                    field.classList.remove('is-invalid');
                }
            });
            
            if (hasErrors) {
                // Stop event BEFORE Rails UJS sees it - button won't be disabled
                e.preventDefault();
                e.stopImmediatePropagation();
                
                // Scroll to first error
                const firstError = form.querySelector('.is-invalid');
                if (firstError) {
                    firstError.scrollIntoView({ 
                        behavior: 'smooth', 
                        block: 'center' 
                    });
                }
                
                // Show user-friendly error message
                showErrorMessage('Please fill in all required fields before submitting.');
            }
        });
        
        // Clear is-invalid on change (for selects) and input (for text fields)
        form.addEventListener('change', function(e) {
            if (e.target.classList.contains('is-invalid')) {
                if (e.target.tagName === 'SELECT') {
                    const selectedOption = e.target.options[e.target.selectedIndex];
                    if (e.target.value.trim() && !(selectedOption && selectedOption.disabled)) {
                        e.target.classList.remove('is-invalid');
                        e.target.removeAttribute('readonly');
                    }
                } else if (e.target.type === 'checkbox') {
                    if (e.target.checked) {
                        e.target.classList.remove('is-invalid');
                    }
                } else if (e.target.value.trim()) {
                    e.target.classList.remove('is-invalid');
                }
            }
        });
        
        form.addEventListener('input', function(e) {
            if (e.target.classList.contains('is-invalid') && e.target.value.trim()) {
                e.target.classList.remove('is-invalid');
            }
        });
    });
}

function setupAjaxRetry() {
    // Override jQuery AJAX to add automatic retry
    const originalAjax = $.ajax;
    
    $.ajax = function(options) {
        const maxRetries = options.maxRetries || 2;
        let retryCount = 0;
        
        function attemptRequest() {
            const originalError = options.error;
            
            options.error = function(xhr, status, error) {
                console.warn(`AJAX attempt ${retryCount + 1} failed:`, status, error);
                
                if (retryCount < maxRetries && (status === 'timeout' || status === 'error')) {
                    retryCount++;
                    console.log(`Retrying AJAX request (attempt ${retryCount + 1}/${maxRetries + 1})`);
                    
                    setTimeout(() => {
                        attemptRequest();
                    }, 1000 * retryCount); // Exponential backoff
                } else {
                    if (originalError) {
                        originalError.call(this, xhr, status, error);
                    }
                }
            };
            
            return originalAjax(options);
        }
        
        return attemptRequest();
    };
}

function handleBrowserNavigation() {
    // Prevent form data loss on navigation - ONLY for booking forms
    window.addEventListener('beforeunload', function(e) {
        // Only check specific booking forms, not all tour forms
        const forms = document.querySelectorAll('#freeTourForm, #sharedTourForm');
        
        for (let form of forms) {
            // Only show warning if form is visible and user has entered data
            if (!form || form.offsetParent === null) continue;
            
            const formData = new FormData(form);
            let hasData = false;
            
            for (let [key, value] of formData.entries()) {
                if (value && value.toString().trim() && 
                    !key.includes('authenticity_token') && 
                    !key.includes('_method')) {
                    hasData = true;
                    break;
                }
            }
            
            if (hasData) {
                e.preventDefault();
                e.returnValue = 'You have unsaved changes. Are you sure you want to leave?';
                return e.returnValue;
            }
        }
    });
}

function showErrorMessage(message) {
    // Remove existing error messages
    const existingMessages = document.querySelectorAll('.booking-error-message');
    existingMessages.forEach(msg => msg.remove());
    
    // Create new error message
    const errorDiv = document.createElement('div');
    errorDiv.className = 'alert alert-danger booking-error-message';
    errorDiv.style.cssText = `
        position: fixed;
        top: 20px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 9999;
        max-width: 90%;
        box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    `;
    errorDiv.innerHTML = `
        <i class="fas fa-exclamation-triangle"></i> ${message}
        <button type="button" class="btn-close" style="float: right; background: none; border: none; font-size: 1.2em;">&times;</button>
    `;
    
    document.body.appendChild(errorDiv);
    
    // Auto-hide after 5 seconds
    setTimeout(() => {
        if (errorDiv.parentNode) {
            errorDiv.remove();
        }
    }, 5000);
    
    // Close button
    errorDiv.querySelector('.btn-close').addEventListener('click', () => {
        errorDiv.remove();
    });
}

// Export functions for external use
window.bookingFormStability = {
    showErrorMessage,
    initialized: () => bookingFormInitialized
};
